(function () {
    'use strict';

    angular
        .module('app')
        .controller('DisplayUserMessageController', DisplayUserMessageController);
    
    function DisplayUserMessageController($scope, $rootScope, $state) {
        var vm = this;
        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }
        $scope.messageData = $rootScope.messageData;
        vm.messageData = $rootScope.messageData;
    }
})();
